import React from 'react';
import LocationTemplate from './LocationTemplate';

const TynerPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Tyner"
      stateName="North Carolina"
      countyName="Chowan"
      zipCodes={["27980"]}
      latitude={36.2282}
      longitude={-76.6569}
      population={868}
      historicalFact="Rural community established in the early 1900s, known for its agricultural heritage."
      nearbyTowns={[
        "Edenton, NC",
        "Hertford, NC",
        "Elizabeth City, NC",
        "Sunbury, NC",
        "Gates, NC",
        "Corapeake, NC",
        "Hobbsville, NC",
        "Winfall, NC"
      ]}
    />
  );
};

export default TynerPage;